import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { AlertService } from 'app/services';
import { SalesService, UserForSalesManagement, UserSalesMessage, UserSalesStatusLog } from 'app/services/sales.service';
import { MessageModalComponentViewModel } from './message-modal.viewmodel';
declare var $:any;

@Component({
	selector: 'mail-history-modal',
	templateUrl: 'mail-history-modal.html'
})
export class MailHistoryModalComponentViewModel {
	isOpen: boolean = false;
	user: UserForSalesManagement;
	logs: UserSalesStatusLog[];

	constructor(private salesService: SalesService, private alertService: AlertService) {
	}



	open(user: UserForSalesManagement) {
		this.logs = null;
		this.user = user;
		let userId = this.user.userId;
		this.salesService.getUserSalesStatusLog(
			userId,
			(values: UserSalesStatusLog[]) => {this.logs = values},
			(error: any) => {this.alertService.error(error)}
		)

		
		this.isOpen = true;
	}

	close() {
		this.isOpen = false;
	}
  
}


// WEBPACK FOOTER //
// ./src/app/containers/user/modal/mail-history-modal.viewmodel.ts